module.exports = __webpack_public_path__ + "media/images/default-product-group-39e8d81ce3a78f4365d7858176de619c.png";